/** Канал листа кандидату: пошта або повідомлення в LinkedIn із розширення. */
export type Channel = 'email' | 'linkedin';

/**
 * Канал внутрішнього сповіщення рекрутера. Push колись планувався, але так і не
 * запрацював — фронт ніколи не отримував токена, а сервіс відхиляв такі правила
 * валідацією. Лишилась пошта (tsp-services#248).
 */
export type SubscriptionChannel = 'email';

export const SUBSCRIPTION_CHANNELS: SubscriptionChannel[] = ['email'];

export interface Rule {
  readonly id: number;
  readonly name: string;
  readonly code: string;
  readonly availableFilters: string[];
  readonly sendgridTemplateId: string;
}

export interface RecruiterRule {
  readonly id: number;
  readonly recruiterId: number;
  readonly userId: number;
  readonly portalId: number;
  readonly ruleId: number;
  readonly channel: SubscriptionChannel;
  readonly filterBy: string | null;
  readonly filterValue: string | null;
}

export interface CreatePayload {
  readonly recruiterId: number;
  readonly portalId: number;
  readonly ruleId: number;
  readonly channel: SubscriptionChannel;
  readonly filterBy: string | null;
  readonly filterValue: string | null;
}
export interface UpdatePayload extends CreatePayload {
  readonly id: number;
}
